import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { MessageService } from '@core/errors/messages-service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { UsersService } from '../../services/users-resolver.service';

import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

@Component({
  selector: 'dialog-archive-or-unarchive-user',
  templateUrl: './dialog-archive-or-unarchive-user.component.html',
  styleUrls: ['./dialog-archive-or-unarchive-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogArchiveOrUnarchiveUserComponent {

  public isLoading = false;
  public isArchived = false;

  private userId: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: { userId: string, isArchived: boolean, isLoading: boolean },
    public readonly matDialogRef: MatDialogRef<DialogArchiveOrUnarchiveUserComponent>,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly customMessageService: CustomMessagesService,
    private fuseProgressBarService: FuseProgressBarService,
    private messageService: MessageService,
    private usersService: UsersService,

  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.userId = this.data.userId;
    this.isArchived = this.data.isArchived;
    this.isLoading = this.data.isLoading;
  }

  public async archiveOrUnarchiveUser(): Promise<void> {
    try {
      this.isLoading = true;
      this.fuseProgressBarService.show();

      if (this.isArchived) {
        await this.usersService.archivedUser(this.userId).toPromise();
        this.customMessageService.success('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.SUCCESS_MESSAGE');
      } else {
        await this.usersService.unarchiveUser(this.userId).toPromise();
        this.customMessageService.success('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.SUCCESS_MESSAGE');
      }
    } catch (error) {
      this.messageService.error(error);
      if (this.isArchived) {
        this.customMessageService.error('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.ARCHIVE.ERROR_MESSAGE');
      } else {
        this.customMessageService.error('ARCHIVE_OR_UNARCHIVE_USER_DIALOG.UNARCHIVE.ERROR_MESSAGE');
      }
    } finally {
      this.isLoading = false;

      this.fuseProgressBarService.hide();
      this.matDialogRef.close({ reload: true });
    }
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }
}
